import React, { useState } from 'react';
import styles from './HomeSettings.module.scss';
import MenuSettings from './MenuSettings';
import GeneralSettings from './GeneralSettings';

/**
 * إعدادات الصفحة الرئيسية — the settings half of the home-page group in the
 * sidebar. `محتوى الصفحة الرئيسية` (HomeSliderPage) is the content half.
 *
 * ⚠ THE 270px SIDE RAIL IS GONE (2026-09-29). It held ONE tab, repeated a word
 * the page heading already said, and cost a third of the viewport; worse, its
 * flex sizing fought the content column, so the screen shipped with the menu
 * list squeezed into ~40% of the page while the rail stretched across the rest.
 *
 * The group can still grow. `SECTIONS` is the same list it always was — it just
 * renders as a compact row of tabs, and ONLY once there is a second section to
 * choose between. One tab is not a choice, so it draws no chrome.
 *
 * Each section renders its own header (title, hint, and whatever live status it
 * alone can know) from the props below, rather than the page reaching into the
 * section for them.
 *
 * Route: /home/home-settings (registered in routes/MainRoutes.jsx).
 * Plan:  DPA-FE `docs/Controlled/MainMenu/04-cms-workplan.md` §2.
 */
const SECTIONS = [
  {
    key: 'menus',
    label: 'إعدادات القوائم',
    title: 'إعدادات القوائم',
    hint: 'تحدد مصدر القوائم التي تظهر في الموقع، وترتيب عناصر كل قائمة.',
    render: (props) => <MenuSettings {...props} />,
  },
  {
    key: 'general',
    label: 'إعدادات عامة',
    title: 'إعدادات عامة',
    hint:
      'إظهار وإخفاء أقسام الصفحة الرئيسية وخدمات الموقع. التغيير يسري على ' +
      'الموقع المباشر فور الحفظ، ولا يُحذف أي محتوى.',
    render: (props) => <GeneralSettings {...props} />,
  },
];

const HomeSettingsPage = () => {
  const [activeKey, setActiveKey] = useState(SECTIONS[0].key);
  const active =
    SECTIONS.find((section) => section.key === activeKey) ?? SECTIONS[0];

  return (
    <div className={styles.page}>
      {SECTIONS.length > 1 && (
        <nav className={styles['section-tabs']} aria-label='أقسام الإعدادات'>
          {SECTIONS.map((section) => (
            <button
              key={section.key}
              type='button'
              className={`${styles['section-tab']} ${
                section.key === activeKey ? styles['section-tab-active'] : ''
              }`}
              onClick={() => setActiveKey(section.key)}
              aria-current={section.key === activeKey ? 'page' : undefined}
            >
              {section.label}
            </button>
          ))}
        </nav>
      )}

      {active.render({ title: active.title, hint: active.hint })}
    </div>
  );
};

export default HomeSettingsPage;
